import { render, staticRenderFns } from "./Comp15t3.vue?vue&type=template&id=62d53966&scoped=true&"
import script from "./Comp15t3.vue?vue&type=script&lang=js&"
export * from "./Comp15t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp15t3.vue?vue&type=style&index=0&id=62d53966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d53966",
  null
  
)

export default component.exports